var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root_data-img",on:{"click":_vm.goRootData}},[(_vm.$i18n.locale === 'zh')?_c('img',{attrs:{"src":_vm.rootDataZhImg,"alt":""}}):_c('img',{attrs:{"src":_vm.rootDataEnImg,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }